import { Link } from 'react-router';
import LegalLayout from './landing/LegalLayout';
import LegalIdentity from './landing/LegalIdentity';
import { usePlatformLegalInfo } from '../hooks/usePlatformLegalInfo';
import { CHATSERVE_URL, CONTACT } from '../content/site';

function TermsOfService() {
  const info = usePlatformLegalInfo();
  const contactEmail = info.contactEmail || CONTACT.email;

  return (
    <LegalLayout
      title="Terms of service"
      description="The terms that apply when you use the EFSoft website and its chat."
      path="/terms-of-service"
      lastUpdated="16 October 2026"
    >
      <section>
        <h2>About these terms</h2>
        <p>
          These terms apply when you use the EFSoft website and the chat on it.
          By using the site you agree to them. Software development work for
          clients is covered by a separate written agreement, which takes
          precedence over these terms for that work.
        </p>
        <LegalIdentity info={info} />
      </section>

      <section>
        <h2>What EFSoft offers</h2>
        <p>
          EFSoft designs, builds, hosts and maintains web applications for
          businesses, and provides software consulting. We also run{' '}
          <a href={CHATSERVE_URL} target="_blank" rel="noopener noreferrer">
            ChatServe
          </a>
          , which has its own terms on its website.
        </p>
      </section>

      <section>
        <h2>Information on this site</h2>
        <p>
          We keep the content of this site accurate, but it is general
          information and not an offer or advice for your situation. Prices,
          timelines and scope are agreed in writing for each project.
        </p>
        <p>
          Replies in the chat are written by an AI model. They can be
          incomplete or wrong, so please confirm anything important with us
          by email or phone before relying on it.
        </p>
      </section>

      <section>
        <h2>Acceptable use</h2>
        <p>
          Do not use the site or the chat to break the law, to send harmful or
          abusive content, or to try to disrupt or gain unauthorised access to
          our systems.
        </p>
      </section>

      <section>
        <h2>Intellectual property</h2>
        <p>
          The text, design, logos and screenshots on this site belong to EFSoft
          or are used with permission. You may view and share links to the
          site, but you may not copy or reuse its content without our written
          permission.
        </p>
      </section>

      <section>
        <h2>Liability</h2>
        <p>
          We provide this website as it is. To the extent the law allows, we
          are not liable for losses that come from using the site or the chat.
          Nothing in these terms limits liability that the law does not allow
          us to limit.
        </p>
      </section>

      <section>
        <h2>Privacy</h2>
        <p>
          How we handle personal data is explained in our{' '}
          <Link to="/privacy-policy">privacy policy</Link>.
        </p>
      </section>

      {info.governingLaw && (
        <section>
          <h2>Governing law</h2>
          <p>These terms are governed by {info.governingLaw}.</p>
        </section>
      )}

      <div className="legal-callout">
        <p>
          Questions about these terms? Email us at{' '}
          <a href={`mailto:${contactEmail}`}>{contactEmail}</a>.
        </p>
      </div>
    </LegalLayout>
  );
}

export default TermsOfService;
